import $ from 'jquery';
import Skrollr from 'skrollr';
import Swiper from 'swiper/dist/js/swiper.js'; // es5 version

function initSwiperCarousel($id, $swipperButtons, loop = false, centeredSlides = true, margin = 30) {
  const carousel = $($id);

  if (!carousel) {
    return;
  }

  const swiper = new Swiper($id, {
    slidesPerView: 'auto',
    centeredSlides: centeredSlides,
    autoHeight: true,
    slideToClickedSlide: true,
    spaceBetween: margin,
    loop: loop,
    breakpoints: {
      992: {
        spaceBetween: 10,
      }
    },
    pagination: {
      el: '.swiper-progressbar-custom__dummy-target',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        const fillEl = swiper.pagination.$el.parent().find('.swiper-progressbar-custom__fill');

        fillEl.css({
          width: 100 / total + '%',
          transform: 'translateX(' + (current - 1) * 100 + '%)'
        });

        return null;
      },
    },
    navigation: {
      nextEl: $swipperButtons.next,
      prevEl: $swipperButtons.prev,
    },
    on: {
      // for some reason init function needs to be in here
      init: function () {
        const video = this.slides[this.activeIndex].querySelector('video');

        if (video) {
          video.addEventListener('loadeddata', function () {
            // swiper is kind of bugged when trying to read the height of a video
            if (!video.height) {
              carousel.height(video.clientHeight);
            }
          });

          video
            .play()
            .catch(function () {
              // play() errored, show video controls on each slide
              this.slides.each(function (i, slide) {
                slide.querySelector('video').controls = true;
              });
            }.bind(this));

          Skrollr.get() && Skrollr.get().refresh();
        }
      }
    },
  });

  swiper.on('slideChangeTransitionEnd', function () {
    // pause all slides
    this.slides.each((i, slide) => {
      let video = slide.querySelector('video');

      if (video) {
        video.pause();
      }
    });

    let activeVideo = this.slides[this.activeIndex].querySelector('video');

    if (activeVideo) {
      // play active slide
      activeVideo.play();
    }
  });
}

export default initSwiperCarousel;